import { render, staticRenderFns } from "./HedgeOSView.vue?vue&type=template&id=9b97d94a&scoped=true"
import script from "./HedgeOSView.vue?vue&type=script&lang=js"
export * from "./HedgeOSView.vue?vue&type=script&lang=js"
import style0 from "./HedgeOSView.vue?vue&type=style&index=0&id=9b97d94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b97d94a",
  null
  
)

export default component.exports